/**
 * Indian mobile numbers, normalised to the ten digits the OTP is sent to.
 *
 * Notion has them every which way — "+91 98765 43210", "09876543210",
 * "9876543210 / 9123456789". The first usable ten-digit mobile wins; anything
 * that is not one (landlines, short numbers, blanks) is null and the dealer is
 * listed for accounts to fix in Notion.
 */
export function normaliseIndianMobile(raw: string | null | undefined): string | null {
  if (!raw) return null;
  // Several numbers in one field: try each part.
  const parts = String(raw).split(/[\/,;|]|\s{2,}|\band\b/i);
  for (const part of parts) {
    const d = part.replace(/\D/g, "");
    let ten = d;
    if (d.length === 12 && d.startsWith("91")) ten = d.slice(2);
    else if (d.length === 11 && d.startsWith("0")) ten = d.slice(1);
    else if (d.length === 13 && d.startsWith("091")) ten = d.slice(3);
    if (/^[6-9]\d{9}$/.test(ten)) return ten;
  }
  return null;
}

/** "98765 43210" for display. */
export function formatIndianMobile(phone: string | null | undefined): string {
  if (!phone) return "—";
  return `+91 ${phone.slice(0, 5)} ${phone.slice(5)}`;
}
